import { Grid, Skeleton } from "@mui/material";
import { Widget } from "Components/Shared/Widget/Widget";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.StatusWidgets;

export const MerchantsStatusWidgetsSkeleton = () => {
  const { t } = useResource();

  return (
    <Grid container spacing={2} alignItems="stretch" my={4}>
      <Widget title={t(RESOURCES.OpenRegistrations)}>
        <NumberSkeleton />
      </Widget>
      <Widget title={t(RESOURCES.InvitationsSent)}>
        <NumberSkeleton />
      </Widget>
      <Widget title={t(RESOURCES.InOnboarding)}>
        <NumberSkeleton />
      </Widget>
      <Widget title={t(RESOURCES.Completed)}>
        <NumberSkeleton />
      </Widget>
    </Grid>
  );
};

const NumberSkeleton = () => <Skeleton variant="text" width={50} height={32} />;
